export {
  default,
  CONSENT_PERSISTENCE_WARNING,
} from "./useConsentPersistenceCheck";
